import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Header from "./components/Header"; // Header component
import Footer from "./components/Footer"; // Footer component
import Home from "./pages/Home"; // Home page
import Login from "./pages/Login"; // Login page
import Register from "./pages/Register"; // Register page
import PostDetails from "./pages/PostDetails"; // PostDetails page
import BloggingPage from "./pages/BloggingPage"; // Blogging page
import ProfilePage from "./pages/ProfilePage";
import BlogDetail from "./pages/BlogDetail";
// Check if the user is logged in
const isLoggedIn = () => {
  return sessionStorage.getItem("isLoggedIn") === "yes";
};

function App() {
  return (
    <Router>
      {/* Sticky Header */}
      <div className="sticky top-0 z-10">
        <Header />
      </div>
      <div className="min-h-screen">
        <Routes>
          {/* Home Page (Accessible to Everyone) */}
          <Route path="/" element={<Home />} />

          {/* Login Page (Redirect to Home if Already Logged In) */}
          <Route
            path="/login"
            element={isLoggedIn() ? <Navigate to="/" /> : <Login />}
          />

          {/* Register Page (Redirect to Home if Already Logged In) */}
          <Route
            path="/register"
            element={isLoggedIn() ? <Navigate to="/" /> : <Register />}
          />

          {/* Post Details Page (Protected) */}
          <Route
            path="/post"
            element={isLoggedIn() ? <PostDetails /> : <Navigate to="/login" />}
          />

          {/* Blogging Page (Protected) */}
          <Route
            path="/blog"
            element={isLoggedIn() ? <BloggingPage /> : <Navigate to="/login" />}
          />

          <Route
            path="/profile"
            element={isLoggedIn() ? <ProfilePage /> : <Navigate to="/login" />}
          />
          <Route path="/genblog/:id" element={<BlogDetail />} />
        </Routes>
      </div>
      <Footer /> {/* Footer */}
    </Router>
  );
}

export default App;
